module.exports = __webpack_public_path__ + "faec0b1ac7a8c598c3e86141a3501201.jpg";